/* Mélé storefront app — vanilla JS port of the melebeauty.shop React app.
   Config lives in window.MELE_CONFIG (set in snippets/mele-modals.liquid). */
(function () {
  'use strict';

  var CFG = window.MELE_CONFIG || {};
  var CDN = CFG.cdnBase || '';
  var PRODUCT = { sku: 'MELE-COMB', handle: 'peigne-rituel-mele', name: 'Le Peigne Rituel Mélé', colors: ['Rose', 'Beige', 'Prune'] };
  var COLOR_HEX = { Rose: '#e8a5a5', Beige: '#d4b89a', Prune: '#7B2D4E' };
  var OFFERS = [
    { id: 'x1', qty: 1, price: 24450, compareAt: 31900, badge: null, badgeCls: '', label: '1 peigne', note: 'Pour commencer ton rituel.' },
    { id: 'x2', qty: 2, price: 36675, compareAt: 43800, badge: 'ÉCONOMISE 7 125', badgeCls: 'bg-[var(--brass)]', label: '2 peignes', note: '1 pour toi, 1 à offrir.' },
    { id: 'x3', qty: 3, price: 48900, compareAt: 65700, badge: 'LE PLUS CHOISI', badgeCls: 'bg-[var(--clay)]', label: '3 peignes', note: 'Le pack famille.' }
  ];
  var UPSELL = { sku: 'MELE-COMB', qty: 1, price: 11250, compareAt: 22500, label: '1 peigne supplémentaire' };
  var COUNTRIES = {
    CI: { flag: '🇨🇮', label: "Côte d'Ivoire", dialCode: '+225', dial: '225', placeholder: '07 00 00 00 00' },
    SN: { flag: '🇸🇳', label: 'Sénégal', dialCode: '+221', dial: '221', placeholder: '77 000 00 00' }
  };
  var FAQ = [
    { q: 'Comment utiliser le peigne Mélé ?', a: "Remplis le réservoir (eau ou ton soin léger), allume, et passe le peigne sur cuir chevelu et longueurs 2–3 minutes. Matin et/ou soir." },
    { q: 'Pour quels types de cheveux ?', a: "Tous : naturels, défrisés, colorés, tissages, bouclés, secs ou à frisottis. Les picots souples s'adaptent." },
    { q: 'Que mettre dans le réservoir ?', a: "De l'eau, un hydrolat, ou un soin capillaire léger. Évite les huiles épaisses qui bouchent le diffuseur." },
    { q: 'La lumière est-elle sans danger ?', a: "C'est une lumière douce, sans chaleur. Tu l'utilises confortablement pendant ton rituel." },
    { q: 'Comment se recharge-t-il ?', a: "Par câble Type-C (universel). Une charge complète dure plusieurs rituels." },
    { q: 'Comment se passe la livraison et le paiement ?', a: "Livraison à domicile en 24–72 h selon ta ville. Tu paies à la livraison, en espèces." },
    { q: 'Et si je ne suis pas satisfaite ?', a: "Tu es couverte par notre garantie 30 jours. Contacte-nous et on s'occupe de tout." }
  ];

  /* ---------- utils ---------- */
  function fmt(n) { return n.toLocaleString('fr-FR', { maximumFractionDigits: 0 }) + ' FCFA'; }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function uuid() { return (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36); }
  function getParam(k) { return new URLSearchParams(window.location.search).get(k); }
  function getCookie(k) { var m = document.cookie.split('; ').find(function (r) { return r.indexOf(k + '=') === 0; }); return m ? m.split('=')[1] : undefined; }

  var ICONS = {
    bag: function (s, cls) { return '<svg xmlns="http://www.w3.org/2000/svg" width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="' + (cls || '') + '" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path><path d="M3 6h18"></path><path d="M16 10a4 4 0 0 1-8 0"></path></svg>'; },
    x: function (s) { return '<svg xmlns="http://www.w3.org/2000/svg" width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>'; },
    trash: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"></path><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>',
    check: '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check text-white" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>',
    lock: '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>'
  };

  /* ---------- pixels & attribution ---------- */
  var ATTR = {};
  function captureAttribution() {
    ATTR = {
      fbp: getCookie('_fbp'),
      fbc: getCookie('_fbc') || (getParam('fbclid') ? 'fb.1.' + Date.now() + '.' + getParam('fbclid') : undefined),
      utm_source: getParam('utm_source') || undefined,
      utm_medium: getParam('utm_medium') || undefined,
      utm_campaign: getParam('utm_campaign') || undefined
    };
    try {
      var saved = JSON.parse(sessionStorage.getItem('mele_attr') || '{}');
      Object.keys(ATTR).forEach(function (k) { if (ATTR[k] === undefined && saved[k]) ATTR[k] = saved[k]; });
      sessionStorage.setItem('mele_attr', JSON.stringify(ATTR));
    } catch (e) {}
  }
  /* Advanced Matching: re-init the pixel with the customer identity we already
     collected, so Meta can match the event to a real person. fbq SHA-256 hashes
     these in-browser; no raw PII is transmitted. */
  var amApplied = false;
  function applyAdvancedMatching(vals) {
    try {
      if (!window.fbq || !CFG.pixelId || !vals) return;
      var c = COUNTRIES[vals.country];
      if (!c) return;
      var local = normalizePhone(vals.phone, vals.country);
      var first = String(vals.name || '').trim().split(/\s+/)[0] || '';
      var last = String(vals.name || '').trim().split(/\s+/).slice(1).join(' ');
      var am = {
        ph: c.dial + local,
        country: vals.country.toLowerCase()
      };
      if (first) am.fn = first.toLowerCase();
      if (last) am.ln = last.toLowerCase();
      window.fbq('init', CFG.pixelId, am);
      amApplied = true;
    } catch (e) {}
  }

  function track(ev, data, eventID) {
    try {
      if (window.fbq) { eventID ? window.fbq('track', ev, data || {}, { eventID: eventID }) : window.fbq('track', ev, data || {}); }
    } catch (e) {}
  }

  /* ---------- phone ---------- */
  function normalizePhone(raw, country) {
    var t = String(raw).replace(/[\s\-().+]/g, '');
    if (t.indexOf('225') === 0 && t.length === 13) t = t.slice(3);
    else if (t.indexOf('221') === 0 && t.length === 12) t = t.slice(3);
    return t;
  }
  function isValidPhone(raw, country) {
    var a = normalizePhone(raw, country);
    if (country === 'CI') return a.length === 10 && ['01', '05', '07'].some(function (p) { return a.indexOf(p) === 0; });
    return a.length === 9 && a.indexOf('7') === 0;
  }
  function sha256Hex(str) {
    if (!(window.crypto && crypto.subtle)) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(str)).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) { return b.toString(16).padStart(2, '0'); }).join('');
    }).catch(function () { return ''; });
  }

  /* ---------- cart state ---------- */
  var cart = { items: [], isOpen: false, isCheckoutOpen: false };
  try { var savedCart = JSON.parse(sessionStorage.getItem('mele_cart') || 'null'); if (savedCart && savedCart.items) cart.items = savedCart.items; } catch (e) {}
  function persist() { try { sessionStorage.setItem('mele_cart', JSON.stringify({ items: cart.items })); } catch (e) {} }
  function cartTotal() { return cart.items.reduce(function (s, it) { return s + it.price; }, 0); }
  function cartCount() { return cart.items.reduce(function (s, it) { return s + it.qty; }, 0); }
  function offerById(id) { for (var i = 0; i < OFFERS.length; i++) if (OFFERS[i].id === id) return OFFERS[i]; return null; }

  function addOffer(offerId, color) {
    var o = offerById(offerId);
    if (!o) return;
    cart.items = [{ offerId: offerId, qty: o.qty, color: color || 'Rose', price: o.price, label: o.label }];
    cart.isOpen = true;
    persist(); renderAll();
    track('AddToCart', { value: o.price, currency: 'XOF', content_name: PRODUCT.name, num_items: o.qty });
  }
  function addUpsellToCart() {
    if (cart.items.some(function (it) { return it.isUpsell; })) return;
    cart.items = cart.items.concat([{ offerId: 'x1', qty: UPSELL.qty, color: 'Rose', price: UPSELL.price, label: 'Upsell — 1 peigne', isUpsell: true }]);
    persist(); renderAll();
  }
  function removeItem(idx) { cart.items = cart.items.filter(function (_, i) { return i !== idx; }); persist(); renderAll(); }
  function updateColor(idx, color) { cart.items = cart.items.map(function (it, i) { return i === idx ? Object.assign({}, it, { color: color }) : it; }); persist(); renderAll(); }
  function clearCart() { cart.items = []; persist(); renderAll(); }
  function openDrawer() { cart.isOpen = true; renderAll(); }
  function closeDrawer() { cart.isOpen = false; renderAll(); }
  function openCheckout() { cart.isOpen = false; cart.isCheckoutOpen = true; renderAll(); }
  function closeCheckout() { cart.isCheckoutOpen = false; renderAll(); }

  /* ---------- header ---------- */
  function renderBadge() {
    var btns = qsa('button[aria-label^="Panier"]');
    var n = cartCount();
    btns.forEach(function (btn) {
      var b = btn.querySelector('[data-mele-badge]');
      if (n > 0) {
        var txt = n > 9 ? '9+' : String(n);
        if (!b) {
          b = document.createElement('span');
          b.setAttribute('data-mele-badge', '');
          b.className = 'absolute -top-0.5 -right-0.5 bg-[var(--clay)] text-[var(--ivory)] text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center';
          btn.appendChild(b);
        }
        b.textContent = txt;
        btn.setAttribute('aria-label', 'Panier — ' + n + ' article' + (n > 1 ? 's' : ''));
      } else if (b) { b.remove(); btn.setAttribute('aria-label', 'Panier'); }
    });
  }
  function wireHeader() {
    qsa('button[aria-label^="Panier"]').forEach(function (b) { b.addEventListener('click', openDrawer); });
    var close = qs('button[aria-label="Fermer l’annonce"]') || qs('button[aria-label="Fermer l\'annonce"]');
    if (close) {
      var bar = close.closest('div.bg-\\[var\\(--espresso\\)\\]') || close.parentElement;
      close.addEventListener('click', function () { if (bar) bar.style.display = 'none'; });
    }
    var burger = qs('button[aria-label="Menu"]');
    var menu = qs('[data-mele-mobile-menu]');
    if (burger && menu) {
      burger.addEventListener('click', function () {
        var open = menu.hasAttribute('hidden');
        if (open) { menu.removeAttribute('hidden'); } else { menu.setAttribute('hidden', ''); }
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        burger.innerHTML = open ? ICONS.x(22) : '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="4" x2="20" y1="12" y2="12"></line><line x1="4" x2="20" y1="6" y2="6"></line><line x1="4" x2="20" y1="18" y2="18"></line></svg>';
      });
    }
  }

  /* ---------- cart drawer ---------- */
  var root;
  function drawerHTML() {
    var items = cart.items, total = cartTotal();
    var inner;
    if (items.length === 0) {
      inner = '<div class="flex flex-col items-center justify-center h-full gap-4 py-16 px-6 text-center">' + ICONS.bag(40, 'text-[var(--sand)]') +
        '<p class="text-[var(--mocha)]">Ton panier est vide pour le moment.</p>' +
        '<button data-act="close-drawer" class="inline-flex items-center justify-center gap-2 font-semibold rounded-[var(--radius)] transition-all duration-200 border-[1.5px] border-[var(--espresso)] text-[var(--espresso)] bg-transparent hover:bg-[var(--sand)] hover:-translate-y-px px-6 py-[0.9rem] text-base min-h-[52px] w-full max-w-xs">Continuer mes achats</button></div>';
    } else {
      var rows = items.map(function (it, i) {
        var colorBtns = PRODUCT.colors.map(function (c) {
          var sel = it.color === c;
          return '<button data-act="color" data-idx="' + i + '" data-color="' + c + '" class="px-2 py-0.5 text-[10px] font-medium rounded-full border transition-colors ' + (sel ? 'border-[var(--clay)] bg-[var(--clay)] text-[var(--ivory)]' : 'border-[var(--sand)] text-[var(--mocha)] hover:border-[var(--mocha)]') + '">' + c + '</button>';
        }).join('');
        return '<div class="flex gap-3 px-5 py-4">' +
          '<div class="w-16 h-16 rounded-[var(--radius-sm)] bg-[var(--sand)] flex-shrink-0 overflow-hidden"><img src="' + CDN + 'mele-product-main.jpg" alt="Peigne Rituel Mélé" class="w-full h-full object-cover"></div>' +
          '<div class="flex-1 min-w-0"><p class="font-semibold text-sm text-[var(--espresso)] leading-snug">' + (it.isUpsell ? 'Peigne Rituel Mélé — Offre spéciale' : 'Peigne Rituel Mélé — ' + esc(it.label)) + '</p>' +
          '<p class="text-xs text-[var(--mocha)] mt-0.5">Qté : ' + it.qty + '</p>' +
          '<div class="flex gap-1.5 mt-2">' + colorBtns + '</div></div>' +
          '<div class="flex flex-col items-end justify-between flex-shrink-0"><span class="font-bold text-[var(--espresso)]">' + fmt(it.price) + '</span>' +
          '<button data-act="remove" data-idx="' + i + '" class="text-[var(--mocha)] hover:text-[var(--danger)] transition-colors p-1" aria-label="Retirer du panier">' + ICONS.trash + '</button></div></div>';
      }).join('');
      var crossSell = '';
      inner = '<div class="divide-y divide-[var(--sand)]">' + rows + '</div>' + crossSell;
    }
    var footer = items.length > 0 ?
      '<div class="border-t border-[var(--sand)] px-5 py-4 space-y-3 bg-[var(--ivory)]">' +
      '<div class="flex justify-between items-center text-[var(--espresso)]"><span class="font-medium">Sous-total</span><span class="font-bold text-lg">' + fmt(total) + '</span></div>' +
      '<p class="text-xs text-[var(--mocha)]">Frais de livraison calculés à la confirmation</p>' +
      '<button data-act="checkout" class="inline-flex items-center justify-center gap-2 font-semibold rounded-[var(--radius)] transition-all duration-200 bg-[var(--clay)] text-[var(--ivory)] hover:bg-[var(--clay-deep)] hover:-translate-y-px active:translate-y-0 px-6 py-[0.9rem] text-base min-h-[52px] w-full cta-pulse">Commander</button>' +
      '<p class="text-xs text-center text-[var(--mocha)]">🔒 Paiement à la livraison · Satisfaite ou remboursée 30 j</p></div>' : '';
    return '<div class="fixed inset-0 z-50 flex" role="dialog" aria-modal="true" aria-label="Ton panier">' +
      '<div data-act="close-drawer" class="flex-1 bg-[var(--espresso)]/40 backdrop-blur-sm"></div>' +
      '<div tabindex="-1" class="w-full max-w-[420px] bg-[var(--ivory)] flex flex-col shadow-[var(--shadow-lg)] animate-fade-in-up md:animate-none" style="max-height:100dvh">' +
      '<div class="flex items-center justify-between px-5 py-4 border-b border-[var(--sand)]">' +
      '<div class="flex items-center gap-2">' + ICONS.bag(18, 'text-[var(--clay)]') + '<h2 class="font-[family-name:var(--font-display)] text-lg font-medium text-[var(--espresso)]">Ton panier</h2></div>' +
      '<button data-act="close-drawer" class="p-2 text-[var(--mocha)] hover:text-[var(--espresso)] rounded-full hover:bg-[var(--sand)] transition-colors" aria-label="Fermer le panier">' + ICONS.x(18) + '</button></div>' +
      '<div class="flex-1 overflow-y-auto">' + inner + '</div>' + footer + '</div></div>';
  }

  /* ---------- checkout modal ---------- */
  var form = { name: '', phone: '', address: '', country: null, errName: '', errPhone: '', errAddress: '', errGlobal: '', loading: false };
  function summaryHTML() {
    var items = cart.items, total = cartTotal();
    var rows = items.map(function (it) {
      return '<div class="flex justify-between text-sm text-[var(--espresso)]"><span>' + (it.isUpsell ? 'Peigne Rituel — offre spéciale' : 'Peigne Rituel — ' + esc(it.label)) + ' <span class="text-[var(--mocha)]">(' + esc(it.color) + ')</span></span><span class="font-semibold flex-shrink-0 ml-2">' + fmt(it.price) + '</span></div>';
    }).join('');
    return '<div class="bg-[var(--sand)] rounded-[var(--radius-sm)] p-3 space-y-2">' + rows +
      '<div class="border-t border-[var(--sand)] pt-2 flex justify-between font-bold text-[var(--espresso)]"><span>Total</span><span>' + fmt(total) + '</span></div></div>';
  }
  function checkoutHTML() {
    var c = form.country;
    var canSubmit = c !== null && form.name.trim().length >= 2 && isValidPhone(form.phone, c) && form.address.trim().length >= 5;
    var countryBtns = ['SN', 'CI'].map(function (k) {
      var d = COUNTRIES[k], sel = c === k;
      return '<button type="button" data-act="country" data-country="' + k + '" aria-pressed="' + sel + '" class="flex items-center justify-center gap-2 rounded-[var(--radius-sm)] border-2 px-4 py-3 text-sm font-semibold transition-all ' + (sel ? 'border-[var(--clay)] bg-[var(--clay)] text-white shadow-sm' : 'border-[var(--sand)] bg-white text-[var(--espresso)] hover:border-[var(--clay)] hover:bg-[var(--cream)]') + '"><span class="text-lg leading-none">' + d.flag + '</span><span>' + d.label + '</span></button>';
    }).join('');
    return '<div class="fixed inset-0 z-[60] flex items-end md:items-center justify-center p-0 md:p-4">' +
      '<div data-act="close-checkout" class="absolute inset-0 bg-[var(--espresso)]/50 backdrop-blur-sm"></div>' +
      '<div role="dialog" aria-modal="true" aria-label="Finaliser ma commande" class="relative bg-[var(--ivory)] w-full max-w-md rounded-t-[24px] md:rounded-[var(--radius)] shadow-[var(--shadow-lg)] max-h-[92dvh] overflow-y-auto animate-fade-in-up">' +
      '<div class="bg-[var(--success)] text-white text-xs font-semibold text-center py-2.5 px-4 flex items-center justify-center gap-2 rounded-t-[24px] md:rounded-t-[var(--radius)]">' + ICONS.lock + 'Aucun paiement maintenant · Tu paies à la livraison</div>' +
      '<div class="px-5 py-5">' +
      '<div class="flex items-start justify-between mb-1"><h2 class="font-[family-name:var(--font-display)] text-xl font-medium text-[var(--espresso)]">Plus qu’une étape.</h2>' +
      '<button data-act="close-checkout" class="p-1 text-[var(--mocha)] hover:text-[var(--espresso)]" aria-label="Fermer">' + ICONS.x(18) + '</button></div>' +
      '<p class="text-sm text-[var(--mocha)] mb-4">Renseigne tes infos, on t’appelle pour confirmer la livraison.</p>' +
      '<div class="flex items-center gap-3 mb-4 py-2"><div class="flex items-center gap-1.5"><div class="flex"><span class="text-sm text-[var(--brass)]">★</span><span class="text-sm text-[var(--brass)]">★</span><span class="text-sm text-[var(--brass)]">★</span><span class="text-sm text-[var(--brass)]">★</span><span class="text-sm text-[var(--sand)]">★</span></div><span class="font-semibold text-[var(--espresso)] text-sm">4.8</span><span class="text-[var(--mocha)] text-sm">(2 347)</span></div><span class="text-xs text-[var(--mocha)]">· 37 commandes aujourd’hui</span></div>' +
      summaryHTML() +
      '<button data-act="edit-order" class="text-xs text-[var(--clay)] hover:underline mt-2 block">Modifier ma commande</button>' +
      '<form data-mele-form class="mt-5 space-y-4" novalidate>' +
      '<input type="text" name="_hp" tabindex="-1" autocomplete="off" class="sr-only" aria-hidden="true">' +
      '<div><label for="mele-name" class="block text-sm font-semibold text-[var(--espresso)] mb-1.5">Nom complet <span aria-hidden="true">*</span></label>' +
      '<input id="mele-name" type="text" autocomplete="name" placeholder="Ex : Awa Koné" value="' + esc(form.name) + '" class="w-full rounded-[var(--radius-sm)] border px-4 py-3 text-[var(--espresso)] bg-white text-base outline-none transition-colors ' + (form.errName ? 'border-[var(--danger)]' : 'border-[var(--sand)] focus:border-[var(--clay)]') + '" required minlength="2">' +
      (form.errName ? '<p class="mt-1 text-xs text-[var(--danger)]">' + esc(form.errName) + '</p>' : '') + '</div>' +
      '<div><p class="block text-sm font-semibold text-[var(--espresso)] mb-2">Ton pays <span aria-hidden="true">*</span></p><div class="grid grid-cols-2 gap-2">' + countryBtns + '</div></div>' +
      '<div><label for="mele-phone" class="block text-sm font-semibold text-[var(--espresso)] mb-1.5">Téléphone <span aria-hidden="true">*</span></label>' +
      '<div class="flex gap-2">' + (c ? '<span class="inline-flex items-center rounded-[var(--radius-sm)] border border-[var(--sand)] bg-[var(--cream)] px-3 text-sm font-medium text-[var(--espresso)] whitespace-nowrap">' + COUNTRIES[c].dialCode + '</span>' : '') +
      '<input id="mele-phone" type="tel" autocomplete="tel" placeholder="' + (c ? COUNTRIES[c].placeholder : 'Choisis d’abord ton pays') + '" value="' + esc(form.phone) + '" ' + (c ? '' : 'disabled') + ' class="flex-1 rounded-[var(--radius-sm)] border px-4 py-3 text-[var(--espresso)] text-base outline-none transition-colors ' + (c ? (form.errPhone ? 'bg-white border-[var(--danger)]' : 'bg-white border-[var(--sand)] focus:border-[var(--clay)]') : 'bg-[var(--sand)]/30 border-[var(--sand)] text-[var(--mocha)] cursor-not-allowed') + '" required></div>' +
      (!c ? '<p class="mt-1 text-xs text-[var(--mocha)]">Sélectionne ton pays ci-dessus pour activer ce champ.</p>' : '') +
      (c && !form.errPhone ? '<p class="mt-1 text-xs text-[var(--mocha)]">On t’appelle sur ce numéro pour confirmer.</p>' : '') +
      (form.errPhone ? '<p class="mt-1 text-xs text-[var(--danger)]">' + esc(form.errPhone) + '</p>' : '') + '</div>' +
      '<div><label for="mele-address" class="block text-sm font-semibold text-[var(--espresso)] mb-1.5">Adresse de livraison <span aria-hidden="true">*</span></label>' +
      '<textarea id="mele-address" autocomplete="street-address" placeholder="Ex : Ouakam, Dakar, villa n° 12 / Cocody, Abidjan, près du supermarché" rows="3" class="w-full rounded-[var(--radius-sm)] border px-4 py-3 text-[var(--espresso)] bg-white text-base outline-none transition-colors resize-none ' + (form.errAddress ? 'border-[var(--danger)]' : 'border-[var(--sand)] focus:border-[var(--clay)]') + '" required minlength="5">' + esc(form.address) + '</textarea>' +
      (form.errAddress ? '<p class="mt-1 text-xs text-[var(--danger)]">' + esc(form.errAddress) + '</p>' : '') + '</div>' +
      (form.errGlobal ? '<div class="rounded-[var(--radius-sm)] bg-[var(--danger)]/10 border border-[var(--danger)]/20 px-4 py-3 text-sm text-[var(--danger)]">' + esc(form.errGlobal) + '</div>' : '') +
      '<button type="submit" ' + (canSubmit && !form.loading ? '' : 'disabled') + ' class="inline-flex items-center justify-center gap-2 font-semibold rounded-[var(--radius)] transition-all duration-200 disabled:opacity-55 disabled:cursor-not-allowed disabled:transform-none bg-[var(--clay)] text-[var(--ivory)] hover:bg-[var(--clay-deep)] hover:-translate-y-px active:translate-y-0 px-6 py-[0.9rem] text-base min-h-[52px] w-full cta-pulse">' +
      (form.loading ? '<span class="h-4 w-4 rounded-full border-2 border-current border-t-transparent animate-spin"></span>Un instant…' : 'Confirmer ma commande') + '</button>' +
      '<p class="text-xs text-center text-[var(--mocha)]">Paiement à la livraison · Satisfaite ou remboursée 30 j</p>' +
      '<p class="text-xs text-center text-[var(--mocha)]/60">Stock limité — commandes traitées dans l’ordre</p>' +
      '</form></div></div></div>';
  }

  /* ---------- upsell modal ---------- */
  var upsellState = { open: false, secs: 12, timer: null, pending: null };
  function upsellHTML() {
    var pct = (upsellState.secs / 12) * 100;
    return '<div class="fixed inset-0 z-[70] flex items-end md:items-center justify-center p-0 md:p-4">' +
      '<div class="absolute inset-0 bg-[var(--espresso)]/70 backdrop-blur-sm"></div>' +
      '<div class="relative bg-[var(--ivory)] w-full max-w-md rounded-t-[24px] md:rounded-[var(--radius)] shadow-[var(--shadow-lg)] overflow-hidden animate-fade-in-up">' +
      '<div class="h-1.5 bg-[var(--sand)]"><div data-mele-upsell-bar class="h-full bg-[var(--clay)] transition-all duration-1000 ease-linear" style="width:' + pct + '%"></div></div>' +
      '<div class="px-5 py-6">' +
      '<div class="flex items-center justify-between mb-3"><span class="text-xs font-bold tracking-widest uppercase text-[var(--clay)]">Offre unique</span>' +
      '<span class="bg-[var(--espresso)] text-[var(--ivory)] px-2 py-0.5 rounded text-sm font-mono min-w-[28px] text-center"><span data-mele-upsell-secs>' + upsellState.secs + '</span>s</span></div>' +
      '<h2 class="font-[family-name:var(--font-display)] text-2xl font-medium text-[var(--espresso)] mb-1">Attends !</h2>' +
      '<p class="text-[var(--mocha)] mb-4">Ajoute un 2ᵉ peigne Mélé à <strong class="text-[var(--clay)]">' + fmt(UPSELL.price) + '</strong> seulement <span class="line-through text-[var(--mocha)]/60">' + fmt(UPSELL.compareAt) + '</span> — parfait à offrir.</p>' +
      '<div class="flex items-center gap-4 bg-[var(--sand)] rounded-[var(--radius-sm)] p-3 mb-5">' +
      '<div class="w-14 h-14 rounded-[var(--radius-sm)] bg-[var(--cream)] flex items-center justify-center flex-shrink-0"><span class="text-[var(--brass)] text-2xl font-serif">M</span></div>' +
      '<div class="flex-1"><p class="font-semibold text-sm text-[var(--espresso)]">Peigne Rituel Mélé</p><p class="text-xs text-[var(--mocha)]">Massage · Brume · Lumière</p>' +
      '<p class="mt-1"><span class="font-bold text-[var(--clay)]">' + fmt(UPSELL.price) + '</span><span class="ml-2 text-xs text-[var(--mocha)] line-through">' + fmt(UPSELL.compareAt) + '</span>' +
      '<span class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold tracking-wide uppercase bg-[var(--clay)] text-[var(--ivory)] ml-2 text-[9px]">-50%</span></p></div></div>' +
      '<button data-act="upsell-accept" class="inline-flex items-center justify-center gap-2 font-semibold rounded-[var(--radius)] transition-all duration-200 bg-[var(--clay)] text-[var(--ivory)] hover:bg-[var(--clay-deep)] hover:-translate-y-px active:translate-y-0 px-6 py-[0.9rem] text-base min-h-[52px] w-full mb-3">Oui, j’ajoute à ' + fmt(UPSELL.price) + '</button>' +
      '<button type="button" data-act="upsell-decline" class="w-full text-center text-sm text-[var(--mocha)] hover:text-[var(--espresso)] py-2 transition-colors">Non merci, continuer</button>' +
      '</div></div></div>';
  }

  /* ---------- order submission ---------- */
  var webhookSent = false;
  function buildPayload(done) {
    var p = upsellState.pending;
    var country = COUNTRIES[p.country];
    var local = normalizePhone(p.phone, p.country);
    var now = new Date();
    var pad = function (n) { return String(n).padStart(2, '0'); };
    sha256Hex(country.dial + local).then(function (hash) {
      done({
        order_id: p.orderId,
        timestamp: now.toISOString(),
        event_time: Math.floor(now.getTime() / 1000),
        product: PRODUCT.name,
        sku: PRODUCT.sku,
        country: p.country,
        name: p.name,
        phone_local: local,
        phone_e164: '+' + country.dial + local,
        phone_display: country.dialCode + ' ' + local,
        phone_sha256: hash,
        address: p.address,
        color: p.color,
        pack: p.pack,
        pack_label: p.packLabel,
        pack_price_fcfa: p.packPrice,
        upsell_accepted: p.upsellAccepted,
        upsell_price_fcfa: p.upsellAccepted ? UPSELL.price : 0,
        total_fcfa: p.total + (p.upsellAccepted ? UPSELL.price : 0),
        currency: 'XOF',
        variant_id: (CFG.variantIds || {})[p.color] || '',
        page_url: window.location.href,
        utm_source: ATTR.utm_source || '',
        utm_medium: ATTR.utm_medium || '',
        utm_campaign: ATTR.utm_campaign || '',
        fbp: ATTR.fbp || '',
        fbc: ATTR.fbc || '',
        client_event_id: p.clientEventId,
        items_json: JSON.stringify(p.items)
      });
    });
  }
  function sendWebhook(cb) {
    if (webhookSent) { cb(); return; }
    webhookSent = true;
    if (!CFG.webhookUrl) { cb(); return; }
    var finished = false;
    var finish = function () { if (!finished) { finished = true; cb(); } };
    buildPayload(function (payload) {
      try {
        fetch(CFG.webhookUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), keepalive: true }).then(finish, finish);
        setTimeout(finish, 2500);
      } catch (e) { finish(); }
    });
  }
  function goMerci(upsellAdded) {
    var p = upsellState.pending;
    try {
      sessionStorage.setItem('mele_order', JSON.stringify({
        am: { phone: p.phone, country: p.country, name: p.name },
        customerName: p.name.split(' ')[0],
        total: p.total + (upsellAdded ? UPSELL.price : 0),
        upsellAdded: !!upsellAdded,
        orderId: p.orderId,
        packLabel: p.packLabel
      }));
    } catch (e) {}
    clearCart();
    window.location.href = '/pages/merci';
  }
  function resolveUpsell(accepted) {
    if (upsellState.timer) { clearInterval(upsellState.timer); upsellState.timer = null; }
    upsellState.open = false;
    upsellState.pending.upsellAccepted = !!accepted;
    if (accepted) track('Purchase', { value: UPSELL.price, currency: 'XOF', content_name: 'Upsell 2e peigne' });
    sendWebhook(function () { goMerci(accepted); });
  }
  function submitOrder(e) {
    e.preventDefault();
    if (!form.country) return;
    form.errName = form.errPhone = form.errAddress = form.errGlobal = '';
    if (form.name.trim().length < 2) { form.errName = 'Entre ton nom complet.'; renderAll(); return; }
    if (!isValidPhone(form.phone, form.country)) { form.errPhone = 'Entre un numéro ivoirien ou sénégalais valide.'; renderAll(); return; }
    if (form.address.trim().length < 5) { form.errAddress = 'Entre une adresse de livraison complète (min. 5 caractères).'; renderAll(); return; }
    var hp = qs('[data-mele-form] input[name="_hp"]');
    if (hp && hp.value) return; /* honeypot */
    form.loading = true; renderAll();
    beginOrderFlow({ name: form.name, phone: form.phone, address: form.address, country: form.country });
  }
  function beginOrderFlow(vals) {
    partial.orderPlaced = true;
    partial.sent = true;
    if (partial.timer) { clearTimeout(partial.timer); partial.timer = null; }
    applyAdvancedMatching(vals);
    var total = cartTotal();
    var clientEventId = uuid();
    var now = new Date();
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var orderId = 'CMD-' + now.getFullYear() + pad(now.getMonth() + 1) + pad(now.getDate()) + '-' + String(Math.floor(1000 + Math.random() * 9000));
    track('Lead', { value: total, currency: 'XOF', num_items: cartCount() }, orderId);
    var main = cart.items.find(function (it) { return !it.isUpsell; }) || cart.items[0];
    upsellState.pending = {
      orderId: orderId,
      clientEventId: clientEventId,
      name: vals.name.trim(),
      phone: vals.phone.trim(),
      address: vals.address.trim(),
      country: vals.country,
      color: main ? main.color : 'Rose',
      pack: main ? main.offerId : 'x1',
      packLabel: main ? main.label : '',
      packPrice: main ? main.price : total,
      total: total,
      upsellAccepted: false,
      items: cart.items.map(function (it) { return { sku: PRODUCT.sku, qty: it.qty, unitPrice: Math.round(it.price / it.qty), tier: it.offerId, color: it.color, isUpsell: !!it.isUpsell }; })
    };
    webhookSent = false;
    form.loading = false;
    cart.isCheckoutOpen = false;
    resolveUpsell(false);
  }
  window.addEventListener('pagehide', function () {
    if (upsellState.pending && !webhookSent && CFG.webhookUrl && navigator.sendBeacon) {
      webhookSent = true;
      buildPayload(function (payload) {
        try { navigator.sendBeacon(CFG.webhookUrl, new Blob([JSON.stringify(payload)], { type: 'text/plain' })); } catch (e) {}
      });
    }
  });

  /* ---------- render / events ---------- */
  function renderAll() {
    renderBadge();
    if (!root) return;
    document.body.style.overflow = (cart.isOpen || cart.isCheckoutOpen || upsellState.open) ? 'hidden' : '';
    root.innerHTML = (cart.isOpen ? drawerHTML() : '') + (cart.isCheckoutOpen ? checkoutHTML() : '') + (upsellState.open ? upsellHTML() : '');
    var f = qs('[data-mele-form]', root);
    if (f) {
      f.addEventListener('submit', submitOrder);
      var ni = qs('#mele-name', root), pi = qs('#mele-phone', root), ai = qs('#mele-address', root);
      if (ni) ni.addEventListener('input', function () { form.name = ni.value; form.errName = ''; syncSubmit(); });
      if (pi) pi.addEventListener('input', function () { form.phone = pi.value; form.errPhone = ''; syncSubmit(); });
      if (ai) ai.addEventListener('input', function () { form.address = ai.value; form.errAddress = ''; syncSubmit(); });
    }
  }
  function syncSubmit() {
    var btn = qs('[data-mele-form] button[type="submit"]');
    if (!btn) return;
    var ok = form.country !== null && form.name.trim().length >= 2 && isValidPhone(form.phone, form.country) && form.address.trim().length >= 5;
    btn.disabled = !(ok && !form.loading);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act]');
    if (!t) return;
    var act = t.getAttribute('data-act');
    if (act === 'close-drawer') closeDrawer();
    else if (act === 'checkout') { openCheckout(); track('InitiateCheckout', { value: cartTotal(), currency: 'XOF' }); }
    else if (act === 'remove') removeItem(parseInt(t.getAttribute('data-idx'), 10));
    else if (act === 'color') updateColor(parseInt(t.getAttribute('data-idx'), 10), t.getAttribute('data-color'));
    else if (act === 'upgrade') { var mainIt = cart.items.find(function (it) { return !it.isUpsell; }); addOffer(t.getAttribute('data-offer'), mainIt ? mainIt.color : 'Rose'); }
    else if (act === 'close-checkout') closeCheckout();
    else if (act === 'edit-order') { closeCheckout(); openDrawer(); }
    else if (act === 'country') { form.country = t.getAttribute('data-country'); form.phone = ''; form.errPhone = ''; renderAll(); var pi2 = qs('#mele-phone'); if (pi2) pi2.focus(); }
    else if (act === 'upsell-accept') resolveUpsell(true);
    else if (act === 'upsell-decline') resolveUpsell(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (upsellState.open) return;
    if (cart.isCheckoutOpen) closeCheckout();
    else if (cart.isOpen) closeDrawer();
  });

  /* ---------- product page ---------- */
  var selectedOffer = 'x2', selectedColor = 'Rose';
  function offerCardHTML(o, sel) {
    var circle = sel
      ? '<div class="mt-0.5 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors border-[var(--clay)] bg-[var(--clay)]">' + ICONS.check + '</div>'
      : '<div class="mt-0.5 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors border-[var(--sand)]"></div>';
    var badge = o.badge ? '<div class="mt-2 ml-8"><span class="inline-flex items-center rounded-full px-2.5 py-0.5 font-semibold tracking-wide uppercase ' + o.badgeCls + ' text-[var(--ivory)] text-[10px]">' + o.badge + '</span></div>' : '';
    return '<div class="flex items-start justify-between gap-2"><div class="flex items-start gap-3">' + circle +
      '<div><p class="font-semibold text-[var(--espresso)] text-sm">' + o.label + '</p><p class="text-xs text-[var(--mocha)] mt-0.5">' + o.note + '</p></div></div>' +
      '<div class="text-right flex-shrink-0"><p class="font-bold text-[var(--espresso)]">' + fmt(o.price) + '</p><p class="text-xs text-[var(--mocha)] line-through">' + fmt(o.compareAt) + '</p></div></div>' + badge;
  }
  function paintBuyBoxes() {
    qsa('[data-mele-buybox]').forEach(function (box) {
      var btns = qsa('button[data-offer]', box);
      btns.forEach(function (b) {
        var o = offerById(b.getAttribute('data-offer'));
        var sel = o.id === selectedOffer;
        b.className = 'w-full text-left rounded-[var(--radius)] border-2 p-4 transition-all ' + (sel ? 'border-[var(--clay)] bg-[var(--cream)]' : 'border-[var(--sand)] bg-white hover:border-[var(--mocha)]');
        b.setAttribute('aria-pressed', sel ? 'true' : 'false');
        b.innerHTML = offerCardHTML(o, sel);
      });
      qsa('button[title]', box).forEach(function (sw) {
        var cName = sw.getAttribute('title');
        if (!(cName in COLOR_HEX)) return;
        var sel = cName === selectedColor;
        sw.className = 'w-8 h-8 rounded-full border-2 transition-all ' + (sel ? 'border-[var(--clay)] scale-110' : 'border-transparent hover:border-[var(--mocha)]');
        sw.setAttribute('aria-pressed', sel ? 'true' : 'false');
      });
      var colorLabel = qs('[data-mele-color-label]', box);
      if (colorLabel) colorLabel.textContent = selectedColor;
      var cta = qs('button[data-mele-cta]', box);
      if (cta) cta.textContent = 'Commander — ' + fmt(offerById(selectedOffer).price).replace(' ', ' ');
    });
    qsa('[data-inl-submit]').forEach(function (ib) { ib.textContent = 'Commander — ' + fmt(offerById(selectedOffer).price); });
  }
  function wireProductPage() {
    var ctas = qsa('button').filter(function (b) { return /Ajouter à mon panier/.test(b.textContent); });
    if (!ctas.length) return;
    /* tag the two buy boxes */
    ctas.forEach(function (cta) { cta.setAttribute('data-mele-cta', ''); });
    qsa('h3').forEach(function (h) {
      if (h.textContent.trim() !== 'Choisis ton rituel.') return;
      var box = h.parentElement;
      box.setAttribute('data-mele-buybox', '');
      var offerBtns = qsa('button[aria-pressed]', box).filter(function (b) { return !b.hasAttribute('title'); });
      offerBtns.slice(0, 3).forEach(function (b, i) {
        b.setAttribute('data-offer', OFFERS[i].id);
        b.addEventListener('click', function () { selectedOffer = OFFERS[i].id; paintBuyBoxes(); });
      });
      qsa('button[title]', box).forEach(function (sw) {
        var cName = sw.getAttribute('title');
        if (!(cName in COLOR_HEX)) return;
        sw.addEventListener('click', function () { selectedColor = cName; paintBuyBoxes(); });
      });
      /* tag the "Coloris : X" label */
      qsa('p', box).forEach(function (p) {
        if (/^Coloris\s*:/.test(p.textContent)) {
          var span = p.querySelector('span');
          if (span) span.setAttribute('data-mele-color-label', '');
        }
      });
    });
    ctas.forEach(function (cta) {
      cta.addEventListener('click', function () {
        var el = document.getElementById('commander');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var n0 = qs('#inl-name');
          if (n0) setTimeout(function () { n0.focus({ preventScroll: true }); }, 450);
        } else { addOffer(selectedOffer, selectedColor); }
      });
    });
    /* ?offer= preselect (links from boutique) */
    var pre = getParam('offer');
    if (pre && offerById(pre)) selectedOffer = pre;
    paintBuyBoxes();
    wireInlineForm();
    wireGallery();
    wireStickyCta();
  }
  function wireGallery() {
    var thumbs = qsa('button[aria-label^="Image "]').filter(function (b) { return /^Image \d/.test(b.getAttribute('aria-label')); });
    var prev = qs('button[aria-label="Image précédente"]');
    var next = qs('button[aria-label="Image suivante"]');
    if (!thumbs.length) return;
    var mainImg = null;
    var gallerySection = thumbs[0].closest('section');
    if (gallerySection) {
      var imgs = qsa('img', gallerySection);
      var thumbImgs = thumbs.map(function (t) { return t.querySelector('img'); });
      mainImg = imgs.find(function (im) { return thumbImgs.indexOf(im) === -1; }) || imgs[0];
    }
    if (!mainImg) return;
    /* thumbnails are served small (?width=200); upgrade to full size for the main image */
    var srcs = thumbs.map(function (t) { var im = t.querySelector('img'); return im ? im.src.replace(/([?&])width=\d+/, '$1width=800') : ''; });
    var alts = thumbs.map(function (t) { var im = t.querySelector('img'); return im ? im.alt : ''; });
    var idx = 0;
    function show(i) {
      idx = (i + thumbs.length) % thumbs.length;
      mainImg.src = srcs[idx];
      mainImg.alt = alts[idx];
      mainImg.removeAttribute('srcset');
      thumbs.forEach(function (t, j) {
        t.classList.toggle('ring-2', j === idx);
        t.classList.toggle('ring-[var(--clay)]', j === idx);
        t.style.opacity = j === idx ? '1' : '0.7';
      });
    }
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { show(j); }); });
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    show(0);
  }
  function wireStickyCta() {
    var bar = document.createElement('div');
    bar.className = 'fixed bottom-0 left-0 right-0 z-40 md:hidden bg-[var(--cream)] border-t border-[var(--sand)] px-4 py-3 shadow-[var(--shadow-lg)]';
    bar.style.display = 'none';
    bar.innerHTML = '<button data-mele-sticky class="inline-flex items-center justify-center gap-2 font-semibold rounded-[var(--radius)] transition-all duration-200 bg-[var(--clay)] text-[var(--ivory)] hover:bg-[var(--clay-deep)] px-6 py-[0.9rem] text-base min-h-[52px] w-full cta-pulse">Commander — Paiement à la livraison</button>' +
      '<p class="text-xs text-center text-[var(--mocha)] mt-1">Paiement à la livraison · Satisfaite ou remboursée 30 j</p>';
    document.body.appendChild(bar);
    bar.querySelector('[data-mele-sticky]').addEventListener('click', function () {
      var el = document.getElementById('commander') || document.getElementById('offre');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    });
    window.addEventListener('scroll', function () {
      var show = window.scrollY > 400;
      if (show) {
        ['commander', 'commander-2'].forEach(function (fid) {
          var fe = document.getElementById(fid);
          if (!fe) return;
          var r = fe.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) show = false;
        });
      }
      bar.style.display = show ? '' : 'none';
    }, { passive: true });
  }

  /* ---------- partial lead capture ---------- */
  /* If a visitor gives a name + valid phone then abandons, send it once so the
     team can follow up on WhatsApp. Never fires after a real order is placed. */
  var partial = { sent: false, timer: null, data: null, orderPlaced: false };
  function partialPayload() {
    var d = partial.data;
    if (!d) return null;
    var c = COUNTRIES[d.country];
    if (!c) return null;
    var local = normalizePhone(d.phone, d.country);
    var o = offerById(selectedOffer) || {};
    var now = new Date();
    return {
      order_id: 'PARTIAL-' + now.getFullYear() + String(now.getMonth() + 1).padStart(2, '0') + String(now.getDate()).padStart(2, '0') + '-' + String(Math.floor(1000 + Math.random() * 9000)),
      lead_type: 'partial',
      timestamp: now.toISOString(),
      event_time: Math.floor(now.getTime() / 1000),
      product: PRODUCT.name,
      sku: PRODUCT.sku,
      country: d.country,
      name: d.name.trim(),
      phone_local: local,
      phone_e164: '+' + c.dial + local,
      phone_display: c.dialCode + ' ' + local,
      address: d.address ? d.address.trim() : '',
      color: selectedColor,
      pack: selectedOffer,
      pack_label: o.label || '',
      pack_price_fcfa: o.price || 0,
      total_fcfa: o.price || 0,
      currency: 'XOF',
      page_url: window.location.href,
      utm_source: ATTR.utm_source || '',
      utm_medium: ATTR.utm_medium || '',
      utm_campaign: ATTR.utm_campaign || '',
      fbp: ATTR.fbp || '',
      fbc: ATTR.fbc || ''
    };
  }
  function sendPartial() {
    if (partial.sent || partial.orderPlaced || !CFG.webhookUrl) return;
    var payload = partialPayload();
    if (!payload) return;
    partial.sent = true;
    try {
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        navigator.sendBeacon(CFG.webhookUrl, new Blob([body], { type: 'text/plain' }));
      } else {
        fetch(CFG.webhookUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true });
      }
    } catch (e) {}
  }
  function notePartial(vals) {
    if (partial.orderPlaced) return;
    if (!vals.country || vals.name.trim().length < 2 || !isValidPhone(vals.phone, vals.country)) return;
    partial.data = vals;
    /* idle fallback: 90 s after the last keystroke with a complete-enough form */
    if (partial.timer) clearTimeout(partial.timer);
    partial.timer = setTimeout(sendPartial, 90000);
  }
  /* leaving the page is the main trigger */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') sendPartial();
  });
  window.addEventListener('pagehide', sendPartial);

  /* ---------- inline order form (form-on-page) ---------- */
  var icStarted = false;
  function icOnce() {
    if (icStarted) return;
    icStarted = true;
    track('InitiateCheckout', { value: offerById(selectedOffer).price, currency: 'XOF' });
  }
  function miniReviewsHTML() {
    var R = [
      { n: 'Aminata S.', v: 'Dakar', t: 'J\u2019avais des doutes mais le paiement \u00e0 la livraison m\u2019a rassur\u00e9e. Re\u00e7ue en 48 h, produit exactement comme d\u00e9crit.' },
      { n: 'Fatou D.', v: 'Dakar', t: 'Frisottis dompt\u00e9s, cuir chevelu apais\u00e9. Livraison rapide, paiement \u00e0 la livraison \u2014 parfait.' },
      { n: 'Rokhaya N.', v: 'Dakar', t: '3 minutes le soir : cheveux brillants et d\u00e9nou\u00e9s. J\u2019en ai command\u00e9 un 2\u1d49 pour offrir.' }
    ];
    return '<div class="mt-3 space-y-2">' + R.map(function (r) {
      return '<div class="bg-[var(--sand)]/60 rounded-[var(--radius-sm)] px-3 py-2.5">' +
        '<div class="flex items-center gap-2 mb-0.5 flex-wrap"><span class="text-[var(--brass)] text-xs">\u2605\u2605\u2605\u2605\u2605</span>' +
        '<span class="text-xs font-semibold text-[var(--espresso)]">' + r.n + '</span>' +
        '<span class="text-[10px] text-[var(--mocha)]">' + r.v + '</span>' +
        '<span class="text-[9px] font-semibold tracking-wide uppercase text-[var(--success)]">Achat v\u00e9rifi\u00e9</span></div>' +
        '<p class="text-xs text-[var(--mocha)] leading-snug">' + r.t + '</p></div>';
    }).join('') + '</div>';
  }
  function inlineFormHTML(idx) {
    var sf = '-' + idx;
    var countryBtns = ['SN', 'CI'].map(function (k) {
      var d = COUNTRIES[k];
      return '<button type="button" data-inl-country="' + k + '" aria-pressed="false" class="flex items-center justify-center gap-2 rounded-[var(--radius-sm)] border-2 px-4 py-3 text-sm font-semibold transition-all border-[var(--sand)] bg-white text-[var(--espresso)] hover:border-[var(--clay)] hover:bg-[var(--cream)]"><span class="text-lg leading-none">' + d.flag + '</span><span>' + d.label + '</span></button>';
    }).join('');
    return '<div class="mt-4 rounded-[var(--radius)] border-2 border-[var(--clay)]/30 bg-white overflow-hidden shadow-[var(--shadow-sm)]">' +
      '<div class="bg-[var(--success)] text-white text-xs font-semibold text-center py-2.5 px-4 flex items-center justify-center gap-2">' + ICONS.lock + 'Aucun paiement maintenant \u00b7 Tu paies \u00e0 la livraison</div>' +
      '<form data-inl-form class="p-4 space-y-4" novalidate>' +
      '<input type="text" name="_hp" tabindex="-1" autocomplete="off" class="sr-only" aria-hidden="true">' +
      '<div><label for="inl-name' + sf + '" class="block text-sm font-semibold text-[var(--espresso)] mb-1.5">Nom complet <span aria-hidden="true">*</span></label>' +
      '<input id="inl-name' + sf + '" data-inl-name type="text" autocomplete="name" placeholder="Ex : Awa Diop" class="w-full rounded-[var(--radius-sm)] border px-4 py-3 text-[var(--espresso)] bg-white text-base outline-none transition-colors border-[var(--sand)] focus:border-[var(--clay)]" required minlength="2">' +
      '<p data-inl-err-name class="mt-1 text-xs text-[var(--danger)]" hidden></p></div>' +
      '<div><p class="block text-sm font-semibold text-[var(--espresso)] mb-2">Ton pays <span aria-hidden="true">*</span></p><div class="grid grid-cols-2 gap-2">' + countryBtns + '</div></div>' +
      '<div><label for="inl-phone' + sf + '" class="block text-sm font-semibold text-[var(--espresso)] mb-1.5">T\u00e9l\u00e9phone <span aria-hidden="true">*</span></label>' +
      '<div class="flex gap-2"><span data-inl-dial class="inline-flex items-center rounded-[var(--radius-sm)] border border-[var(--sand)] bg-[var(--cream)] px-3 text-sm font-medium text-[var(--espresso)] whitespace-nowrap" hidden></span>' +
      '<input id="inl-phone' + sf + '" data-inl-phone type="tel" autocomplete="tel" placeholder="Choisis d\u2019abord ton pays" disabled class="flex-1 rounded-[var(--radius-sm)] border px-4 py-3 text-base outline-none transition-colors bg-[var(--sand)]/30 border-[var(--sand)] text-[var(--mocha)] cursor-not-allowed"></div>' +
      '<p data-inl-hint class="mt-1 text-xs text-[var(--mocha)]">S\u00e9lectionne ton pays ci-dessus pour activer ce champ.</p>' +
      '<p data-inl-err-phone class="mt-1 text-xs text-[var(--danger)]" hidden></p></div>' +
      '<div><label for="inl-address' + sf + '" class="block text-sm font-semibold text-[var(--espresso)] mb-1.5">Adresse de livraison <span aria-hidden="true">*</span></label>' +
      '<textarea id="inl-address' + sf + '" data-inl-address autocomplete="street-address" placeholder="Ex : Ouakam, Dakar, villa n\u00b0 12 / Cocody, Abidjan, pr\u00e8s du supermarch\u00e9" rows="3" class="w-full rounded-[var(--radius-sm)] border px-4 py-3 text-[var(--espresso)] bg-white text-base outline-none transition-colors resize-none border-[var(--sand)] focus:border-[var(--clay)]" required minlength="5"></textarea>' +
      '<p data-inl-err-address class="mt-1 text-xs text-[var(--danger)]" hidden></p></div>' +
      '<button type="submit" disabled data-inl-submit class="inline-flex items-center justify-center gap-2 font-semibold rounded-[var(--radius)] transition-all duration-200 disabled:opacity-55 disabled:cursor-not-allowed disabled:transform-none bg-[var(--clay)] text-[var(--ivory)] hover:bg-[var(--clay-deep)] hover:-translate-y-px active:translate-y-0 px-6 py-[0.9rem] text-base min-h-[52px] w-full cta-pulse">Commander \u2014 ' + fmt(offerById(selectedOffer).price) + '</button>' +
      '<p class="text-xs text-center text-[var(--mocha)]">\ud83d\udd12 On t\u2019appelle pour confirmer \u00b7 Satisfaite ou rembours\u00e9e 30 j</p>' +
      '</form></div>';
  }
  function buildInlineForm(box, idx) {
    if (qs('[data-inl-form]', box)) return;
    var st = { name: '', phone: '', address: '', country: null, loading: false };
    var wrap = document.createElement('div');
    wrap.id = idx === 0 ? 'commander' : 'commander-' + (idx + 1);
    wrap.innerHTML = inlineFormHTML(idx) + (idx === 0 ? miniReviewsHTML() : '');
    var cta = qs('button[data-mele-cta]', box);
    if (cta) { cta.style.display = 'none'; cta.insertAdjacentElement('beforebegin', wrap); }
    else { box.appendChild(wrap); }
    var f = qs('[data-inl-form]', wrap);
    var ni = qs('[data-inl-name]', wrap), pi = qs('[data-inl-phone]', wrap), ai = qs('[data-inl-address]', wrap);
    var dial = qs('[data-inl-dial]', wrap), hint = qs('[data-inl-hint]', wrap);
    function hideErr(k) { var el = qs('[data-inl-err-' + k + ']', wrap); if (el) el.hidden = true; }
    function showErr(k, msg) { var el = qs('[data-inl-err-' + k + ']', wrap); if (el) { el.textContent = msg; el.hidden = false; } }
    function syncInl() {
      var btn = qs('[data-inl-submit]', wrap);
      if (!btn) return;
      var ok = st.country !== null && st.name.trim().length >= 2 && isValidPhone(st.phone, st.country) && st.address.trim().length >= 5;
      btn.disabled = !(ok && !st.loading);
    }
    ni.addEventListener('focus', icOnce);
    ai.addEventListener('focus', icOnce);
    ni.addEventListener('input', function () { st.name = ni.value; hideErr('name'); syncInl(); notePartial(st); });
    pi.addEventListener('input', function () { st.phone = pi.value; hideErr('phone'); syncInl(); notePartial(st); });
    ai.addEventListener('input', function () { st.address = ai.value; hideErr('address'); syncInl(); notePartial(st); });
    qsa('[data-inl-country]', wrap).forEach(function (b) {
      b.addEventListener('click', function () {
        icOnce();
        st.country = b.getAttribute('data-inl-country');
        qsa('[data-inl-country]', wrap).forEach(function (o) {
          var sel = o === b;
          o.setAttribute('aria-pressed', sel ? 'true' : 'false');
          o.className = 'flex items-center justify-center gap-2 rounded-[var(--radius-sm)] border-2 px-4 py-3 text-sm font-semibold transition-all ' + (sel ? 'border-[var(--clay)] bg-[var(--clay)] text-white shadow-sm' : 'border-[var(--sand)] bg-white text-[var(--espresso)] hover:border-[var(--clay)] hover:bg-[var(--cream)]');
        });
        var d = COUNTRIES[st.country];
        dial.textContent = d.dialCode; dial.hidden = false;
        pi.disabled = false;
        pi.placeholder = d.placeholder;
        pi.className = 'flex-1 rounded-[var(--radius-sm)] border px-4 py-3 text-[var(--espresso)] text-base outline-none transition-colors bg-white border-[var(--sand)] focus:border-[var(--clay)]';
        if (hint) hint.textContent = 'On t\u2019appelle sur ce num\u00e9ro pour confirmer.';
        pi.focus();
        syncInl();
        notePartial(st);
      });
    });
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!st.country) return;
      if (st.name.trim().length < 2) { showErr('name', 'Entre ton nom complet.'); return; }
      if (!isValidPhone(st.phone, st.country)) { showErr('phone', 'Entre un num\u00e9ro ivoirien ou s\u00e9n\u00e9galais valide.'); return; }
      if (st.address.trim().length < 5) { showErr('address', 'Entre une adresse de livraison compl\u00e8te (min. 5 caract\u00e8res).'); return; }
      var hp = qs('input[name="_hp"]', f);
      if (hp && hp.value) return;
      var o = offerById(selectedOffer);
      cart.items = [{ offerId: selectedOffer, qty: o.qty, color: selectedColor, price: o.price, label: o.label }];
      persist();
      track('AddToCart', { value: o.price, currency: 'XOF', content_name: PRODUCT.name, num_items: o.qty });
      beginOrderFlow({ name: st.name, phone: st.phone, address: st.address, country: st.country });
    });
  }
  function wireInlineForm() {
    qsa('[data-mele-buybox]').forEach(function (box, idx) { buildInlineForm(box, idx); });
  }

  /* ---------- WhatsApp ---------- */
  function wireWhatsAppFloat() {
    if (!CFG.waNumber) return;
    if (window.location.pathname.indexOf('/pages/merci') === 0) return;
    var a = document.createElement('a');
    a.href = 'https://wa.me/' + CFG.waNumber + '?text=' + encodeURIComponent('Bonjour ! J\u2019ai une question sur le Peigne Rituel M\u00e9l\u00e9 \ud83c\udf38');
    a.target = '_blank'; a.rel = 'noopener';
    a.setAttribute('aria-label', 'Nous \u00e9crire sur WhatsApp');
    a.className = 'fixed z-40 left-4 bottom-28 md:bottom-6 w-12 h-12 rounded-full flex items-center justify-center';
    a.style.cssText = 'background:#25D366;box-shadow:0 4px 14px rgba(0,0,0,.25)';
    a.innerHTML = '<svg viewBox="0 0 32 32" width="26" height="26" fill="#fff" aria-hidden="true"><path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.2 1.6 6L4 29l8.2-1.5c1.2.6 2.5.9 3.8.9 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 21.8c-1.2 0-2.4-.3-3.5-.8l-.6-.3-4.9.9 1-4.7-.3-.6c-.8-1.4-1.2-3-1.2-4.5 0-5.2 4.3-9.4 9.5-9.4s9.5 4.2 9.5 9.4-4.3 10-9.5 10zm5.2-7.4c-.3-.1-1.7-.8-1.9-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.8-.7-1.4-1.6-1.6-1.9-.2-.3 0-.4.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.1c-.2-.5-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.1-.3-.2-.6-.4z"/></svg>';
    document.body.appendChild(a);
  }

  /* ---------- FAQ accordions ---------- */
  function wireFaq() {
    qsa('button[aria-expanded="false"]').forEach(function (btn) {
      if (btn.getAttribute('aria-label') === 'Menu') return;
      var qSpan = btn.querySelector('span');
      if (!qSpan) return;
      var qText = qSpan.textContent.trim();
      var item = FAQ.find(function (f) { return f.q === qText; });
      if (!item) return;
      var panel = document.createElement('div');
      panel.className = 'px-5 pb-4 text-sm text-[var(--mocha)] leading-relaxed bg-[var(--ivory)]';
      panel.textContent = item.a;
      panel.hidden = true;
      btn.insertAdjacentElement('afterend', panel);
      btn.addEventListener('click', function () {
        var open = panel.hidden;
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var chev = btn.querySelector('svg');
        if (chev) chev.style.transform = open ? 'rotate(180deg)' : '';
      });
    });
  }

  /* ---------- merci page ---------- */
  function wireMerci() {
    if (window.location.pathname.indexOf('/pages/merci') !== 0 && window.location.pathname !== '/merci') return;
    var data = null;
    try { data = JSON.parse(sessionStorage.getItem('mele_order') || 'null'); } catch (e) {}
    if (!data) return;
    if (data.am) applyAdvancedMatching(data.am);
    var nameEl = qs('[data-mele-merci-name]');
    if (nameEl && data.customerName) nameEl.textContent = data.customerName;
    var totalEl = qs('[data-mele-merci-total]');
    var lineEl = qs('[data-mele-merci-line]');
    if (data.total) {
      var packPart = data.total - (data.upsellAdded ? UPSELL.price : 0);
      if (lineEl) lineEl.textContent = fmt(packPart);
      if (totalEl) totalEl.textContent = fmt(data.total);
      if (data.upsellAdded && lineEl) {
        var row = lineEl.closest('div');
        if (row) {
          var extra = document.createElement('div');
          extra.className = row.className;
          extra.innerHTML = '<span class="text-[var(--mocha)] text-sm">2ᵉ peigne — offre spéciale</span><span class="font-medium text-[var(--espresso)]">' + fmt(UPSELL.price) + '</span>';
          row.insertAdjacentElement('afterend', extra);
        }
      }
    }
    if (CFG.waNumber) {
      var totEl = qs('[data-mele-merci-total]');
      var card = totEl ? totEl.closest('div[class*="shadow"]') : null;
      if (card) {
        var waMsg = 'Bonjour ! Je confirme ma commande' + (data.orderId ? ' ' + data.orderId : '') + ' \u2014 ' + (data.packLabel ? data.packLabel + ', ' : '') + 'total ' + fmt(data.total || 0) + '.';
        var wa = document.createElement('a');
        wa.href = 'https://wa.me/' + CFG.waNumber + '?text=' + encodeURIComponent(waMsg);
        wa.target = '_blank'; wa.rel = 'noopener';
        wa.className = 'inline-flex items-center justify-center gap-2 font-semibold rounded-[var(--radius)] px-6 py-[0.9rem] text-base min-h-[52px] w-full mb-6 text-white';
        wa.style.cssText = 'background:#25D366;box-shadow:0 2px 10px rgba(37,211,102,.4)';
        wa.innerHTML = '<svg viewBox="0 0 32 32" width="20" height="20" fill="#fff" aria-hidden="true"><path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.2 1.6 6L4 29l8.2-1.5c1.2.6 2.5.9 3.8.9 6.6 0 12-5.4 12-12S22.6 3 16 3z"/></svg>Confirmer ma commande sur WhatsApp';
        card.insertAdjacentElement('afterend', wa);
      }
    }
    track('Purchase', { value: data.total || 0, currency: 'XOF', content_name: PRODUCT.name });
  }

  /* ---------- boot ---------- */
  function boot() {
    root = document.getElementById('mele-modal-root');
    if (!root) { root = document.createElement('div'); root.id = 'mele-modal-root'; document.body.appendChild(root); }
    captureAttribution();
    wireHeader();
    wireProductPage();
    wireFaq();
    wireMerci();
    wireWhatsAppFloat();
    renderBadge();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
